import React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
} from "@mui/material";
import PageHeader from "./layout/PageHeader";
import StatsCard from "./layout/StatsCard";
import StoreIcon from "@mui/icons-material/Store";
import InventoryIcon from "@mui/icons-material/Inventory";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PeopleIcon from "@mui/icons-material/People";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

const localUser = JSON.parse(localStorage.getItem("kdmUser"));

export default function ModernDashboard() {
  // Ces données seraient normalement récupérées depuis votre API
  const stats = [
    {
      title: "Points de vente",
      value: "12",
      icon: StoreIcon,
      color: "primary",
      trend: "up",
      trendValue: "+2",
    },
    {
      title: "Articles",
      value: "248",
      icon: InventoryIcon,
      color: "info",
      trend: "up",
      trendValue: "+18",
    },
    {
      title: "Ventes totales",
      value: "CHF 12,450",
      icon: MonetizationOnIcon,
      color: "success",
      trend: "up",
      trendValue: "+12.5%",
    },
    {
      title: "Clients",
      value: "1,234",
      icon: PeopleIcon,
      color: "secondary",
      trend: "up",
      trendValue: "+45",
    },
  ];

  const recentActivity = [
    {
      title: "Nouvelle vente",
      description: "Article #1234 vendu à CHF 45.00",
      time: "Il y a 5 minutes",
    },
    {
      title: "Nouveau client",
      description: "Client ajouté via formulaire web",
      time: "Il y a 1 heure",
    },
    {
      title: "Article modifié",
      description: "Prix mis à jour pour Menu #23",
      time: "Il y a 2 heures",
    },
  ];

  return (
    <Box>
      <PageHeader
        title={`Bienvenue, ${localUser?.email?.split("@")[0] || "Admin"}`}
        subtitle="Voici un aperçu de votre activité"
      />

      {/* Stats Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={6} lg={3} key={index}>
            <StatsCard {...stat} />
          </Grid>
        ))}
      </Grid>

      {/* Content Grid */}
      <Grid container spacing={3}>
        {/* Welcome Card */}
        <Grid item xs={12} lg={8}>
          <Card
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <CardContent sx={{ p: 4, position: "relative", zIndex: 1 }}>
              <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
                Admin • Kadomi.ch
              </Typography>
              <Typography variant="body1" sx={{ mb: 1, opacity: 0.95 }}>
                Bienvenue sur l'espace d'administration de Kadomi.ch
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.9 }}>
                Saisissez vos articles, ajoutez vos plateformes de ventes de
                choix et vendez vos articles.
              </Typography>
            </CardContent>
            {/* Decorative circles */}
            <Box
              sx={{
                position: "absolute",
                top: -50,
                right: -50,
                width: 200,
                height: 200,
                borderRadius: "50%",
                background: "rgba(255, 255, 255, 0.1)",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: -30,
                right: 100,
                width: 100,
                height: 100,
                borderRadius: "50%",
                background: "rgba(255, 255, 255, 0.1)",
              }}
            />
          </Card>
        </Grid>

        {/* Recent Activity */}
        <Grid item xs={12} lg={4}>
          <Card sx={{ height: "100%" }}>
            <CardContent sx={{ p: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 3 }}>
                Activité récente
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                {recentActivity.map((activity, index) => (
                  <Box key={index} sx={{ display: "flex", gap: 2 }}>
                    <Avatar
                      sx={{
                        width: 40,
                        height: 40,
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      }}
                    >
                      <TrendingUpIcon fontSize="small" />
                    </Avatar>
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, mb: 0.5 }}
                      >
                        {activity.title}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: "block", mb: 0.5 }}
                      >
                        {activity.description}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {activity.time}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
